<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { fade } from 'svelte/transition';
	import NavigationExpandHeader from './navigationExpandHeader.svelte';
	import { type ButtonV3Props } from '../buttonV3.svelte';
	import NavMenuBarLink from './navMenuBarLink.svelte';
	import { subNavigation } from '$lib/state/subNavigation.svelte';

	interface Props {
		content: ISbStoryData<{
			theme: 'light' | 'dark';
			center_navigation: ISbStoryData['content'][];
			right_navigation: ISbStoryData<ButtonV3Props | NavMenuBarLink>['content'][];
			highlighted_links: ISbStoryData['content'][];
			highlighted_links_label: string;
			standard_links_left: ISbStoryData['content'][];
			standard_links_right: ISbStoryData['content'][];
			teaser_cards: ISbStoryData['content'][];
		}>['content'];
	}

	let { content }: Props = $props();
	let passedHeader = $state(false);

	$effect(() => {
		const heroElement = document.getElementById('hero');

		if (!heroElement) return;

		const observer = new IntersectionObserver(
			(entries) => {
				passedHeader = !entries[0].isIntersecting;
			},
			{ threshold: 0 }
		);
		observer.observe(heroElement);

		return () => {
			observer.disconnect();
		};
	});
</script>

<div class="absolute inset-x-0 top-0 z-50">
	<NavigationExpandHeader {content} />
</div>

{#if passedHeader && !subNavigation.available}
	<div transition:fade={{ duration: 150 }} class="fixed inset-x-0 top-0 z-50">
		<NavigationExpandHeader {content} passedHeader={true} />
	</div>
{/if}
